getMutableTarget